enum Route {
  CONNECTING = "CONNECTING",
  CHOOSE_NICKNAME = "CHOOSE_NICKNAME",
  MAIN_MENU = "MAIN_MENU",
  CREATE_GROUP_LOBBY = "CREATE_GROUP_LOBBY",
  JOIN_GROUP = "JOIN_GROUP",
  RESTAURANT_CATEGORIES = "RESTAURANT_CATEGORIES",
  RESTAURANT_CATEGORIES_LOBBY = "RESTAURANT_CATEGORIES_LOBBY",
  TOP_CHOICES = "TOP_CHOICES",
  TOP_RESTAURANTS_LOBBY = "TOP_RESTAURANTS_LOBBY",
  FINAL_RESULT = "FINAL_RESULT",
}

export default Route;
